module.exports = __webpack_public_path__ + "static/media/testimonialContentone.0304cdf1.png";